<template>
  <div class="container">
    <div class="blogDetailsHero">
      <img :src="blog.image[0].url" style="height: 212.72px; width: 300.8px" />
    </div>
    <div class="blogDetailsCard">
      <h2 class="blog-title">
        {{ blog.title }}
      </h2>
      <div class="titleUnderText">
        <div class="blogAuther">
          Upskill
        </div>
        <div class="blogTime">
          {{ getTime(blog.publishedtime) }}
        </div>
      </div>
      <hr class="hrTag1" />
      <div class="blog-body" v-html="blog.content"></div>
      <hr class="hrTag1" />
      <!--      <div class="blogShare">Share</div>-->
    </div>
    <!-- <h1>Blog Details: {{ blogId }}</h1> -->
    <div class="readMoreBlogs">
      <h1 class>Recent Blogs</h1>
    </div>
    <section class="section blog-list">
      <div class="container">
        <div class="second-row">
          <div class="list">
            <div class="blog-post" v-for="b in blogs.slice(0, 5)" :key="b.id">
              <router-link
                :to="{
                  name: 'blog details',
                  params: { blogId: b.id }
                }"
              >
                <a class="inner">
                  <img
                    :src="b.image[0].url"
                    style="object-fit: cover; width: 100%;"
                  />
                  <div class="blog-post-info">
                    <h3 class="post-title">{{ b.title.slice(0, 30) }}...</h3>
                    <p class="post-published-at">
                      {{ getTime(b.publishedtime) }}
                    </p>
                    <p class="post-read-time">
                      {{ getTimeLeft(b.publishedtime) }}
                    </p>
                  </div>
                </a>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- <pre>{{ BlogData }}</pre> -->
  </div>
</template>

<script>
var moment = require("moment");
export default {
  data() {
    return {
      blogs: [],
      blog: {}
    };
  },
  props: ["blogId"],
  head: {
    meta: function() {
      return [
        { p: "og:title", content: this.blog.title },
        { p: "og:image", c: this.blog.image[0].url },
        { p: "og:description", c: "Read more on Upskill's website" },
        { p: "og:url", c: `https://upskill.com.bd/blog/${this.blogId}` }
      ];
    }
  },
  methods: {
    getTime(wstime) {
      return moment(wstime).format("ddd, DD MMMM, YYYY");
    },
    getTimeLeft(bgtime) {
      return moment(bgtime).fromNow();
    }
  },
  created() {
    this.$upskill.blogs().then(res => {
      this.blogs = res.data;
      this.blog = res.data.find(b => b.id == this.blogId);
      this.$emit("updateHead");
      //console.log(this.blog);
      this.Loaded();
    });
  }
};
</script>

<style lang="scss" scoped>
* {
  // outline: 1px yellow solid;
}

img {
  width: 300px;
}
.blog-body {
  font-size: 18px;
  font-family: "Open Sans";
}
.container {
  // min-width: inherit;
  display: flex;
  flex-direction: column;
  justify-content: center;
  .blogDetailsHero {
    // min-width: inherit;
    margin: 0 auto;

    // justify-content: center;
    // background-color: red;
    // min-width: auto;
    img {
      object-fit: cover;
      min-width: 86vw;
      min-height: 50vh;
    }
  }
  .blogDetailsCard {
    display: flex;
    flex-direction: column;
    justify-content: center;
    /*background-color: #f8f8fa;*/
    //margin: -36vh 16vw 20vh 16vw;
    padding: 8vh 10vw 10vh 10vw;

    h2 {
      // background-color: greenyellow;
      justify-content: center;
      font-weight: 600;
      font-family: "Roboto", sans-serif;
    }
    hr.hrTag1 {
      // border: 1px solid #5e5e61b7;
    }
    .titleUnderText {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
  }
  .readMoreBlogs {
    display: flex;

    justify-content: center;
    padding-bottom: 34px;
  }
}
@media screen and (max-width: 800px) {
  .blogDetailsCard {
    margin: 0;
    padding: 1em;
  }
  .blog-title {
    font-size: 21px;
  }
  .blogDetailsHero img {
    width: 100%;
    height: auto;
  }
}
</style>
